import { render, staticRenderFns } from "./SubmitFormPage.vue?vue&type=template&id=3f965447&scoped=true"
import script from "./SubmitFormPage.vue?vue&type=script&lang=js"
export * from "./SubmitFormPage.vue?vue&type=script&lang=js"
import style0 from "./SubmitFormPage.vue?vue&type=style&index=0&id=3f965447&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f965447",
  null
  
)

export default component.exports